import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBubble4: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconBubble4"><Path d="M20.252 6.75C20.252 5.09315 18.9088 3.75 17.252 3.75H6.75195C5.0951 3.75 3.75195 5.09315 3.75195 6.75V21.75L7.50875 19.402C7.66768 19.3027 7.85133 19.25 8.03875 19.25H17.252C18.9088 19.25 20.252 17.9069 20.252 16.25V6.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconBubble4;
